import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const containerStyle = css`
  width: 300px;
  border-right: 1px solid ${theme.colors.neutral20};
  overflow-y: scroll;
`;
